import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" – ")
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!

  return (_ctx.references.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('general.documentReferences')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.realmShort')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.documentReferenceHeader')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.referenceNumber')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.date')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('review.review.entry.validFor')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.attachment')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references, (reference) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: reference.documentReferenceId
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reference.documentReferenceRealm), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reference.documentReferenceReference), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reference.documentReferenceGz), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, {
                      value: reference,
                      noDefault: ""
                    }, {
                      default: _withCtx(() => [
                        (reference.documentReferenceCreated != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$d(new Date(reference.documentReferenceCreated * 1000))), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reference.sinceDocumentVersionVersionParta + reference.sinceDocumentVersionVersionPartSeperator + reference.sinceDocumentVersionVersionPartb), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]),
                    _hoisted_4,
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(reference.untilDocumentVersionVersionParta + reference.sinceDocumentVersionVersionPartSeperator + reference.sinceDocumentVersionVersionPartb), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: reference }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          type: "button",
                          class: "btn btn-sm btn-outline-secondary",
                          href: `/cdes-dojo-impl/repositoryDownload/documentRef/${_ctx.ctx.activeOrganisationPersonId}/${reference.documentReferenceId}`,
                          target: "_blank"
                        }, _hoisted_7, 8, _hoisted_5)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}